export default "__VITE_ASSET__V77pBcG7__"